import './index.css'
import React from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import logUtil from 'utils/log'
import useIsSmallScreen from 'hooks/use-is-small-screen'
import classNames from 'classnames'
import View from 'components/View'

export default function MediaItemMediaVideo (props) {
  const { mediaItem, className: classNameParam } = props
  const videoRef = React.useRef()

  const className = classNames(classNameParam, {
    'media-item-video': true
  })
  const debugProps = { className, props }
  logUtil('MediaItemMediaVideo').debug('[start] debugProps=', debugProps)

  const showControls = () => {
    playerRef.current?.controls(true)
  }

  const handleClick = () => {
    showControls()
  }

  const handleTouchStart = () => {
    showControls()
  }

  const handleError = (error) => {
    logUtil('MediaItemMediaVideo#handleError').error('error=', error)
  }

  const isMobile = useIsSmallScreen()
  const sources = mediaItem.sources || []
  const mp4Sources = sources.filter(source => source.format === 'mp4')
  const mp4MobileQualitySource = mp4Sources.find(source => source.height === 720)
  const playerRef = React.useRef()
  // const hlsSource = sources.find(source => source.format === 'm3u8')
  // if (!hlsSource) {
  //   source = isMobile ? mp4MobileQualitySource : mp4Sources[0]
  // }

  React.useEffect(() => {
    const videoJsOptions = {
      controls: false,
      autoplay: false,
      loop: true,
      muted: true,
      preload: 'auto',
      sources: [
        {
          src: source?.url,
          type: source?.mimeType
        }
      ]
    }
    playerRef.current = videojs(videoRef.current, videoJsOptions, () => {
      logUtil('MediaItemMediaVideo#WorkoutVideoPlay').debug('[ready]')
    })
  }, [])

  const source = isMobile ? mp4MobileQualitySource : mp4Sources[0]

  return (
    <View
      className={className}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
    >
      <video
        ref={videoRef}
        playsInline
        className='video-js'
        onError={handleError}
        autoPlay
        loop
        muted
        preload='auto'
      >
        <p className='vjs-no-js'>
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a
            href='https://videojs.com/html5-video-support/MediaVideo.js'
            target='_blank' rel='noreferrer'
          >
            supports HTML5 video
          </a>
        </p>
      </video>
    </View>
  )
}
